import getDefaultFocusedViewFilterForSelectedFolder from '../utils/FocusedInboxUtil';
import { getFindConversationShape, getFindItemShape } from 'owa-mail-store';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import getSortByFolderId from 'owa-mail-folder-store/lib/selectors/getSortByFolderId';
import {
    MailFolderTableQuery,
    TableQuery,
    TableQueryType,
    SortBy,
    MailFolderScenarioType,
} from 'owa-mail-list-store';
import getDefaultInboxClassificationFilterForFolder from '../utils/getDefaultInboxClassificationFilterForFolder';
import { isFavoritesSearchFolderScenario } from 'owa-mail-list-store';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';

/**
 * Create the table query to load a mail folder
 * @param folderId the folderId
 * @param listViewType the list view type
 * @param scenarioType the type of scenario
 * @param focusedViewfilter the focusedViewfilter
 * @param viewFilter the viewFilter
 * @param categoryName the category name [this will have a value when create query for a category table]
 * @param sortBy the sortBy (column and direction)
 * @param inboxClassificationFilter the inbox classification filter (e.g. newsletters, promotions)
 * @return tableQuery the tableQuery that needed to load a mail folder
 */
export default function createMailFolderTableQuery(
    folderId: string,
    listViewType: ReactListViewType,
    scenarioType: MailFolderScenarioType,
    focusedViewFilter?: FocusedViewFilter,
    viewFilter?: ViewFilter,
    categoryName?: string,
    sortBy?: SortBy,
    inboxClassificationFilter?: InboxClassificationFilter
): TableQuery {
    const viewFilterToSet = viewFilter ? viewFilter : 'All';
    const sortByToSet = sortBy ? sortBy : getSortByFolderId(folderId);
    const focusedViewFilterToSet =
        focusedViewFilter == null
            ? getDefaultFocusedViewFilterForSelectedFolder(folderId)
            : focusedViewFilter;

    const inboxClassificationFilterToSet =
        inboxClassificationFilter == null
            ? getDefaultInboxClassificationFilterForFolder(folderId)
            : inboxClassificationFilter;

    let requestShapeName;
    switch (listViewType) {
        case ReactListViewType.Conversation:
            requestShapeName = getFindConversationShape(
                folderId,
                isFavoritesSearchFolderScenario(scenarioType)
            );
            break;

        case ReactListViewType.Message:
            requestShapeName = getFindItemShape();
            break;
    }

    const folderTableQuery: MailFolderTableQuery = {
        folderId: folderId,
        focusedViewFilter: focusedViewFilterToSet,
        listViewType: listViewType,
        viewFilter: viewFilterToSet,
        sortBy: sortByToSet,
        requestShapeName: requestShapeName,
        type: TableQueryType.Folder,
        shouldTryToUseSessionDataResponse: true,
        categoryName: categoryName,
        scenarioType: scenarioType,
        inboxClassificationFilter: inboxClassificationFilterToSet,
    };

    return folderTableQuery;
}
